import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollProcessService } from 'app/core/services/payroll-process.service';
import { PrivateService } from 'app/core/services/private.service';
import { ProcessSchedulerService } from 'app/core/services/process-scheduler.service';
import { ToastrService } from 'ngx-toastr';
import { Observable, startWith, map } from 'rxjs';
import { DialogProcessTimesheetComponent } from '../dialog-process-timesheet/dialog-process-timesheet.component';

@Component({
  selector: 'dialog-process-import-timesheet',
  templateUrl: './dialog-process-import-timesheet.component.html',
  styleUrls: ['./dialog-process-import-timesheet.component.scss']
})
export class DialogProcessImportTimesheetComponent implements OnInit {

  payrolls: any[] = [];
  period: any[] = [];
  processForm: FormGroup;
  processForm2: FormGroup;
  schedules: any[] = [];

  filteredPayrolls: any[] = [];
  filteredPeriods: any[] = [];
  filteredSchedules: any[] = [];

  payrollSearchText: string = '';
  periodSearchText: string = '';
  scheduleSearchText: string = '';

  selectedPayroll: number | null = null;
  selectedPeriod: string | null = null;

  isLoading: boolean = false;
  isProcessed: boolean = false;
  message: string = '';
  statusList: any[] = [];
  status: string = '';
  useSchedule: boolean = false;
  selectedSchedule: number | null = null;

  constructor(public dialogRef: MatDialogRef<DialogProcessTimesheetComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private privateService: PrivateService, private fb: FormBuilder, private processSchedulerService: ProcessSchedulerService,
    private toastr: ToastrService, private payrollProcessService: PayrollProcessService) {
    this.processForm2 = this.fb.group({
      payroll: [0, Validators.required],
      period: ['', Validators.required],
      exclude: [false],
    });
  }

  ngOnInit(): void {
    this.getPayrolls();

    if (this.data.Payroll_Type_ID > 0) {
      this.privateService.getPayrollType().subscribe(res => {
        this.payrolls = res;
        this.filteredPayrolls = [...res];

        this.privateService.getPeriodOnDepartment(this.data.Payroll_Type_ID).subscribe(response => {
          this.period = response;
          this.filteredPeriods = [...response];

          this.selectedPayroll = +this.data.Payroll_Type_ID;
          this.selectedPeriod = String(this.data.HR_Period_ID);

          this.processForm2.patchValue({
            payroll: +this.data.Payroll_Type_ID,
            period: String(this.data.HR_Period_ID)
          });
        });
      });
    }

    if (this.data.docStatus === 'Drafted') {
      this.status = 'DR';
    }
    if (this.data.docStatus === 'In Progress') {
      this.status = 'IP';
    }
    if (this.data.docStatus === 'Completed') {
      this.status = 'CO';
    }
  }

  private _filter(value: string, list: any[], key: string): any[] {
    const filterValue = value?.toLowerCase() || '';
    return list?.filter(item => item[key]?.toLowerCase().includes(filterValue));
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getPayrolls() {
    this.privateService.getPayrollType().subscribe(res => {
      this.payrolls = res;
      this.filteredPayrolls = [...res];
    });
  }

  onPayrollChange(event: any): void {
    // Value is already set by formControlName
    this.processForm2.patchValue({
      period: '' // Reset period when payroll changes
    });

    // Load periods for selected payroll
    this.privateService.getPeriodOnDepartment(event.value).subscribe(response => {
      this.period = response;
      this.filteredPeriods = [...response];
    });
  }

  onPeriodChange(event: any): void {
    this.selectedPeriod = event.value;
    this.processForm2.get('period')?.setValue(event.value);
  }

  onPayrollDropdownOpenChange(opened: boolean): void {
    if (opened) {
      this.payrollSearchText = '';
      this.filteredPayrolls = [...this.payrolls];
    }
  }

  onPeriodDropdownOpenChange(opened: boolean): void {
    if (opened) {
      this.periodSearchText = '';
      this.filteredPeriods = [...this.period];
    }
  }

  onDropdownOpenChange(opened: boolean): void {
    if (opened) {
      this.scheduleSearchText = '';
      this.filteredSchedules = [...this.schedules];
    }
  }

  filterPayrolls(): void {
    const searchValue = this.payrollSearchText.toLowerCase();
    this.filteredPayrolls = this.payrolls.filter(payroll =>
      payroll.payrollType?.toLowerCase().includes(searchValue)
    );
  }

  filterPeriods(): void {
    const searchValue = this.periodSearchText.toLowerCase();
    this.filteredPeriods = this.period.filter(period =>
      period.payrollName?.toLowerCase().includes(searchValue)
    );
  }

  getPayrollName(payrollId: number | null): string {
    if (!payrollId) return '';
    const payroll = this.payrolls.find(p => p.hrpayrollID === payrollId);
    return payroll ? payroll.payrollType : '';
  }

  getPeriodName(periodId: string | null): string {
    if (!periodId) return '';
    const period = this.period.find(p => p.hrperiodID === periodId);
    return period ? period.payrollName : '';
  }

  onSubmit(): void {
    this.isLoading = true;

    // Mark all fields as touched to show validation errors
    Object.keys(this.processForm2.controls).forEach(key => {
      this.processForm2.get(key)?.markAsTouched();
    });

    if (this.processForm2.invalid) {
      this.showNotificationError("Form is Invalid. Please select both Payroll and Period.");
      this.isLoading = false;
      return;
    }

    const formData = {
      payroll: this.processForm2.get('payroll')?.value,
      period: this.processForm2.get('period')?.value,
      exclude: this.processForm2.get('exclude')?.value,
      timesheetID: this.data.id,
      employeeID: this.data.C_BPartner_ID,
      status: this.status
    };

    console.log('Request payload:', formData);

    this.processSchedulerService.insert_import_timesheet_process_immediate(formData).subscribe({
      next: (res) => {
        console.log('Response received:', res);
        this.isLoading = false;
        this.isProcessed = true;
        this.message = res.message || 'Process completed';
      },
      error: (error) => {
        console.error('Error occurred:', error);
        this.isLoading = false;
        this.showNotificationError('An error occurred while processing the timesheet.');
      }
    });
  }

  showNotificationError(text) {
    this.toastr.success('<span class="now-ui-icons ui-1_bell-53"></span> ' + text + '', '', {
      timeOut: 3000,
      closeButton: true,
      enableHtml: true,
      toastClass: "alert alert-danger alert-with-icon",
      positionClass: 'toast-' + 'top' + '-' + 'center'
    });
  }
}